(function(){
  "use strict";

  angular
    .module('irricrops')


    .factory("CuartelRes", ['urls', '$resource', function(urls, $resource){
      return $resource(urls.BASE+'/sector-riego/:action', {},{
        deleteMensaje:{
          method: 'DELETE',
          params: {
            action: 'mensaje'
          }
        },
        getData:{
          method: 'GET',
        },
        get:{
          method: 'GET',
        },
        getEstados:{
          method: 'GET',
          params:{
            action: 'estados'
          }
        },
        getEstadisticas:{
          method: 'GET',
          params:{
            action: 'estadistica'
          }
        },
        getSemana:{
          method: 'GET',
          params:{
            action:'semana'
          }
        },
        getTemporada:{
          method: 'GET',
          params:{
            action:'temporada'
          }
        },

        getCalicatas:{
          method: 'GET',
          params:{
            action:'calicatas'
          }
        },

        getSensores:{
          method: 'GET',
          params:{
            action:'sensores'
          }
        },
        getSimulacion:{
          method: 'GET',
          params:{
            action:'simulador'
          }
        },
        getMensaje:{
          method: 'GET',
          params:{
            action:'mensaje'
          }
        },
        riegoPendiente:{
          method: 'POST',
          params:{
            action: 'riego-pendiente'
          }
        },
        mensaje:{
          method: 'POST',
          params:{
            action: 'mensaje'
          }
        },
        riegoDia:{
          method: 'POST',
          params:{
            action: 'datos-riego-dia'
          }
        },
        riegoSemana:{
          method: 'POST',
          params:{
            action: 'datos-riego-semana'
          }
        },
        crecimiento:{
          method: 'POST',
          params:{
            action: 'crecimiento-fruta'
          }
        },
        postEstadosFenologicos:{
          method: 'POST',
          params:{
            action: 'estados-fenologicos'
          }
        },
        deleteEstadosFenologicos:{
          method: 'DELETE',
          params:{
            action: 'estado-fenologico'
          }
        },

      });
    }])



  .factory("CuartelFac", ['CuartelRes', '$q', 'newCacheManager', 'global',function(CuartelRes, $q, NCM, global){


    var cache = function(a){
      var nameData = a.nameData;
      var id       = a.id;
      var date     = a.date || null;
      var data     = {};
      var defered  = null;
      var dataAjax = a.dataAjax;
      var thenFn   = a.thenFn;
      var fn       = a.fn;
      var prom     = null;
      var dateUnix = moment(date).unix();

      if (angular.isDefined(NCM.get(nameData, id, dateUnix))) {
        defered = $q.defer();
        prom    = defered.promise;
        data    = {
          data: NCM.get(nameData, id, dateUnix),
          errors: false
        };
        defered.resolve(data);
        if (thenFn !== undefined) {
          thenFn(data);
        }
      }else{
        prom = CuartelRes[fn](dataAjax).$promise;
        if (thenFn !== undefined) {
          prom.then(thenFn);
        }
        prom.then(function(data){
          NCM.set(nameData, id, data.data, dateUnix);
        });
      }
      return prom;
    };



    return {
      getData: function (data, thenFn) {
        return cache({
          nameData : "cuartel.data",
          id       : data.sector_riego_id,
          dataAjax : data,
          date     : data.fecha || null,
          thenFn   : thenFn,
          fn       : 'get'
        });
      },

      getEstadisticas: function (data, thenFn) {
        return cache({
          nameData: "cuartel.estadisticas",
          id: data.sector_riego_id,
          dataAjax: data,
          date: data.fecha || null,
          thenFn: thenFn,
          fn: 'getEstadisticas'
        });
      },

      getEstados: function (data, thenFn) {
        return cache({
          nameData : "cuartel.estados",
          id       : data.sector_riego_id,
          dataAjax : data,
          date     : data.fecha || null,
          thenFn   : thenFn,
          fn       : 'getEstados'
        });
      },

      getSemana: function (data, thenFn) {
        //sera mejor con cache?
        return CuartelRes.getSemana(data, thenFn);
      },

      getTemporada: function (data, thenFn) {
        //sera mejor con cache?
        return CuartelRes.getTemporada(data, thenFn);
      },

      getSimulacion: function (data, thenFn) {
        //sera mejor con cache?
        return CuartelRes.getSimulacion(data, thenFn);
      },


      riegoPendiente:function(data, thenFn){
        id = data.sector_riego_id;
        prom = CuartelRes.riegoPendiente(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.equipo.resumen.riego",
              id,
              global.getChildren('equipo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },



      riegoDia:function(data, thenFn){
        id = data.sector_riego_id;
        prom = CuartelRes.riegoDia(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.equipo.programacion",
              id,
              global.getChildren('equipo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },





      riegoSemana:function(data, thenFn){
        id = data.sector_riego_id;
        prom = CuartelRes.riegoSemana(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.equipo.programacion",
              id,
              global.getChildren('equipo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },

    };

  }]);
})();
